export { Redirect as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/Redirect.js
// module id = 1191
// module chunks = 0